import { urlBuilder } from '@starjack/utils';
import { baseApi } from '@starjack/api';
import { B2BUserWithCredentials } from '../model/b2b.types';

type GetB2BResponse = {
    b2bUsers: B2BUserWithCredentials[];
};

export const b2bUrls = () => ({
    b2b: urlBuilder('auth', 'b2b'),
});

export const b2bApi = baseApi
    .enhanceEndpoints({ addTagTypes: ['B2B'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getB2BUsers: builder.query<GetB2BResponse, void>({
                query: () => b2bUrls().b2b,
                providesTags: ['B2B'],
            }),
        }),
    });

export const { useGetB2BUsersQuery } = b2bApi;
